const FIELD_CLASS = 'gfield';
const ACTIVE_CLASS = 'gfield--active';
const INVALID_CLASS = 'gfield--invalid';
const REQUIRED_TEXT_CLASS = 'gfield_required_text';
const DISABLE_PLACEHOLDER_CLASS = 'gfield-placeholder--hide';
const UPLOAD_RULES_CLASS = 'gform_fileupload_rules';
const RADIO_CONTAINER_CLASS = 'gfield_radio';
const RADIO_CHOICE_CLASS = 'gchoice';
const BUTTON_CLASS = 'button';

class GForm {
    constructor() {
        this._inputFields = document.querySelectorAll(`.${FIELD_CLASS} input`);
        this._inputFields && this._run();
    }
    _run() {
        this._styleRadioAsButtons();
        this._replaceRequiredText();
        this._replaceUploadRulesText();
        this._inputFields.forEach((inputField) => {
            this._togglePlaceholder(inputField);
            inputField.addEventListener('focus', this._activateField);
            inputField.addEventListener('blur', this._deactivateField);
            inputField.addEventListener('input', this._togglePlaceholder);
        });
    }
    _styleRadioAsButtons() {
        const choices = document.querySelectorAll(`.${RADIO_CONTAINER_CLASS}>.${RADIO_CHOICE_CLASS}>label`);
        choices &&
            choices.forEach((choice) => {
                choice.classList.add(BUTTON_CLASS);
            });
    }
    _togglePlaceholder(e) {
        const element = e.target ?? e;
        const inputTypes = ['text', 'email', 'tel'];
        const parent = element.closest(`.${FIELD_CLASS}`);
        if (element.value !== '' && parent && inputTypes.includes(element.type)) {
            parent.classList.add(DISABLE_PLACEHOLDER_CLASS);
        } else {
            parent.classList.remove(DISABLE_PLACEHOLDER_CLASS);
        }
    }
    _replaceUploadRulesText() {
        const uploadRulesText = document.querySelectorAll(`.${UPLOAD_RULES_CLASS}`);
        uploadRulesText &&
            uploadRulesText.forEach((rulesText) => {
                let text = rulesText.innerHTML;
                rulesText.innerHTML = text
                    .toLocaleLowerCase()
                    .replace('accepted file types', 'file type')
                    .replace(/, max.*/, '');

                rulesText.innerHTML;
            });
    }
    _replaceRequiredText() {
        const requiredTextElements = document.querySelectorAll(`.${REQUIRED_TEXT_CLASS}`);
        requiredTextElements &&
            requiredTextElements.forEach((element) => {
                element.innerHTML = '*';
            });
    }
    _activateField(e) {
        const parent = e.target.closest(`.${FIELD_CLASS}`);
        parent && parent.classList.add(ACTIVE_CLASS);
    }
    _deactivateField(e) {
        const parent = e.target.closest(`.${FIELD_CLASS}`);
        parent && parent.classList.remove(ACTIVE_CLASS);
    }
}
const gForm = new GForm();
